var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1D73D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4004 8C14.7434 8.00005 15.0744 8.12595 15.3307 8.35384C15.587 8.58173 15.7508 8.89575 15.7909 9.23633L15.8007 9.40015V15.8213L19.5915 19.6115C19.8427 19.8634 19.9885 20.2015 19.9993 20.5571C20.0102 20.9127 19.8853 21.259 19.65 21.5259C19.4147 21.7927 19.0866 21.96 18.7324 21.9937C18.3782 22.0274 18.0245 21.9251 17.743 21.7075L17.6114 21.5913L13.4103 17.3908C13.1927 17.173 13.0529 16.8896 13.0126 16.5843L13 16.4009V9.40015C13 9.02881 13.1475 8.67268 13.4102 8.4101C13.6728 8.14752 14.029 8 14.4004 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.c04bdf4dc4063c0bd523526eda9cbe6c.svg";
export { ForwardRef as ReactComponent };